/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.professional-development.lcap'},
});

const LcapItem = () => (
  <RouteLinkItem
    route="midas/settings/professional-development/lcap"
    title={messages.title}
  />
);

export default LcapItem;
